import styled from 'styled-components'
import Flex from '../../../../components/Flex'

export const Wrapper = styled(Flex)`
  display: flex;
  flex-direction: column;

  width: 50%;
  padding-top: 2%;
  margin-left: 4%;
  padding: 0px 5px 100px 5px;
`

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    min-width: 10vw;
  }
`
export const SelectWrapper = styled.div`
  width: 50%;
`
export const RichWrapper = styled.div`
  padding-top: 10px;
`

export const LabelDiv = styled.div`
  width: 100%;
  position: relative;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.01em;
  color: rgb(112, 112, 112) !important;
  padding-bottom: 10px;
  padding-top: 10px;
`
